import { VerticalAlignMiddleOutlined } from "@ant-design/icons";
import { Button, Empty } from "antd";
import { t } from "i18next";
import { observer } from "mobx-react-lite";
import * as React from "react";
import { debounce, DebounceCounter } from "src/common/debounce";

import { MfErrorsListStore } from "../MfErrorsListStore";
import * as styles from "./MfErrorsListExpanded.module.less";
import { MfErrorsListTable } from "./MfErrorsListTable";

type PropsMfErrorsListExpanded = {
  store: MfErrorsListStore;
};

export const MfErrorsListExpanded: React.FC<PropsMfErrorsListExpanded> =
  observer(({ store }) => {
    const { height, allErrors } = store;

    const [dragStartState, setDragStartState] = React.useState<
      [number, number]
    >([0, 0]);
    const refContainer = React.useRef<HTMLDivElement>(null);
    const handleDragStart = (e: React.DragEvent) => {
      const blankDragImg = document.createElement("span");
      e.dataTransfer.effectAllowed = "move";
      e.dataTransfer.setDragImage(blankDragImg, 0, 0);
      setDragStartState([e.clientY, refContainer.current?.offsetHeight ?? 0]);
    };

    const calcHeight = (clientY: number) => {
      const [startY, startHeight] = dragStartState;
      const currentHeight = startHeight - (clientY - startY);
      return currentHeight;
    };

    const handle = (clientY: number, _noSave?: boolean) => {
      debounce(debounceCounter, 10, () => {
        if (clientY !== 0) {
          store.changeHeight(calcHeight(clientY));
        }
      });
    };

    const handleDrag = (event: React.DragEvent) => handle(event.clientY, true);

    const handleDragEnd = (event: React.DragEvent) => handle(event.clientY);

    return (
      <div className={styles.expandedBox} ref={refContainer} style={{ height }}>
        <div
          className={styles.splitter}
          draggable
          onDragStart={handleDragStart}
          onDrag={handleDrag}
          onDragEnd={handleDragEnd}
        >
          <div className={styles.bar} />
        </div>
        <div className={styles.header}>
          <div className={styles.title}>Ошибки и предупреждения</div>
          <Button
            size="small"
            icon={<VerticalAlignMiddleOutlined />}
            onClick={() => store.collapse()}
          />
        </div>
        {/* Есть два варианта пустого списка: (1) ошибок нет; (2) они скрыты фильтром. Здесь только вариант (1). (2) в компоненте таблицы */}
        {allErrors.length === 0 ? (
          <div className={styles.emptyBox}>
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description="Нет ошибок"
            />
            <Button onClick={() => store.hide()}>{t("Close")}</Button>
          </div>
        ) : (
          <MfErrorsListTable store={store} />
        )}
      </div>
    );
  });

const debounceCounter: DebounceCounter = {};
